import classNames from "classnames";
import styles from "./AscHeading.module.scss";
import { ReactNode } from "react";

export interface AscHeadingProps {
  children: string | ReactNode;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  className?: string | string[];
  loading?: boolean;
}

export default function AscHeading({
  children,
  level = 1,
  className,
  loading = false,
}: AscHeadingProps) {
  const Tag = `h${level}` as keyof JSX.IntrinsicElements;

  return (
    <Tag
      className={classNames(styles.heading, styles[`h${level}`], className, {
        [styles.loading]: loading,
      })}
    >
      {children}
    </Tag>
  );
}
